import de from './locales/de';
import en from './locales/en';
import fr from './locales/fr';
import es from './locales/es';
import ar from './locales/ar';
import zh from './locales/zh';
import hi from './locales/hi';
import id from './locales/id';
import ru from './locales/ru';
import pt from './locales/pt';
import vi from './locales/vi';
import it from './locales/it';
import nl from './locales/nl';
import ja from './locales/ja';
import ko from './locales/ko';
import tr from './locales/tr';
import pl from './locales/pl';
import sv from './locales/sv';
import th from './locales/th';
import he from './locales/he';
import uk from './locales/uk';
import el from './locales/el';
import cs from './locales/cs';
import ro from './locales/ro';
import hu from './locales/hu';
import da from './locales/da';
import no from './locales/no';
import fi from './locales/fi';
import ms from './locales/ms';
import bn from './locales/bn';
import sw from './locales/sw';
import ur from './locales/ur';
import ta from './locales/ta';
import te from './locales/te';

export const translations = {
  de,
  en,
  fr,
  es,
  ar,
  zh,
  hi,
  id,
  ru,
  pt,
  vi,
  it,
  nl,
  ja,
  ko,
  tr,
  pl,
  sv,
  th,
  he,
  uk,
  el,
  cs,
  ro,
  hu,
  da,
  no,
  fi,
  ms,
  bn,
  sw,
  ur,
  ta,
  te,
};

export const languages = [
  { code: "de", name: "Deutsch", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "en", name: "English", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "fr", name: "Français", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "es", name: "Español", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "ar", name: "العربية", flag: "\u{1F1F8}\u{1F1E6}", rtl: true },
  { code: "zh", name: "中文", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "hi", name: "हिन्दी", flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "id", name: "Bahasa Indonesia", flag: "\u{1F1EE}\u{1F1E9}" },
  { code: "ru", name: "Русский", flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "pt", name: "Português", flag: "\u{1F1F5}\u{1F1F9}" },
  { code: "vi", name: "Tiếng Việt", flag: "\u{1F1FB}\u{1F1F3}" },
  { code: "it", name: "Italiano", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "nl", name: "Nederlands", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "ja", name: "日本語", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "ko", name: "한국어", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "tr", name: "Türkçe", flag: "\u{1F1F9}\u{1F1F7}" },
  { code: "pl", name: "Polski", flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "sv", name: "Svenska", flag: "\u{1F1F8}\u{1F1EA}" },
  { code: "th", name: "ไทย", flag: "\u{1F1F9}\u{1F1ED}" },
  { code: "he", name: "עברית", flag: "\u{1F1EE}\u{1F1F1}", rtl: true },
  { code: "uk", name: "Українська", flag: "\u{1F1FA}\u{1F1E6}" },
  { code: "el", name: "Ελληνικά", flag: "\u{1F1EC}\u{1F1F7}" },
  { code: "cs", name: "Čeština", flag: "\u{1F1E8}\u{1F1FF}" },
  { code: "ro", name: "Română", flag: "\u{1F1F7}\u{1F1F4}" },
  { code: "hu", name: "Magyar", flag: "\u{1F1ED}\u{1F1FA}" },
  { code: "da", name: "Dansk", flag: "\u{1F1E9}\u{1F1F0}" },
  { code: "no", name: "Norsk", flag: "\u{1F1F3}\u{1F1F4}" },
  { code: "fi", name: "Suomi", flag: "\u{1F1EB}\u{1F1EE}" },
  { code: "ms", name: "Bahasa Melayu", flag: "\u{1F1F2}\u{1F1FE}" },
  { code: "bn", name: "বাংলা", flag: "\u{1F1E7}\u{1F1E9}" },
  { code: "sw", name: "Kiswahili", flag: "\u{1F1F9}\u{1F1FF}" },
  { code: "ur", name: "اردو", flag: "\u{1F1F5}\u{1F1F0}", rtl: true },
  { code: "ta", name: "தமிழ்", flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "te", name: "తెలుగు", flag: "\u{1F1EE}\u{1F1F3}" },
];

export const currencies = [
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "RUB", symbol: "₽", name: "Russian Ruble" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
  { code: "MXN", symbol: "$", name: "Mexican Peso" },
  { code: "KRW", symbol: "₩", name: "South Korean Won" },
  { code: "THB", symbol: "฿", name: "Thai Baht" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { code: "PLN", symbol: "zł", name: "Polish Zloty" },
  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { code: "ILS", symbol: "₪", name: "Israeli Shekel" },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia" },
  { code: "RON", symbol: "lei", name: "Romanian Leu" },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
  { code: "DKK", symbol: "kr", name: "Danish Krone" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "PKR", symbol: "Rs", name: "Pakistani Rupee" },
  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
];